import styled from '@emotion/styled'

import { Container } from '@/components/Container'
import { Media } from '@/components/Media'

interface Props {
  videoId: string
  width: number
  height: number
  aspectRatio: '16x9' | '4x3' | 'fixed'
}

const BlogVideoBlockStyled = styled(Container)<Pick<Props, 'aspectRatio'>>((props) => ({
  ...(props.aspectRatio === 'fixed' && {
    '& .video': {
      display: 'flex',
      justifyContent: 'center',
    },
  }),
}))

const BlogVideoBlock = ({ videoId, width, height, aspectRatio = '16x9' }: Props) => (
  <BlogVideoBlockStyled spaceOut="s" spaceIn="s" aspectRatio={aspectRatio}>
    <div className="video">
      <Media
        video={{ url: videoId }}
        height={height}
        width={width}
        type="video"
        layout="responsive"
        aspectRatio={aspectRatio}
      />
    </div>
  </BlogVideoBlockStyled>
)

export default BlogVideoBlock
